import { useState } from "preact/hooks";

import { Hourglass, Page } from "@attaditya/iconoir-preact";
import { Button } from "@components/ui/interactive/button";
import { Container } from "@components/ui/structure/container";
import { Table } from "@components/ui/structure/table";
import { Heading } from "@components/ui/text/heading";
import { Text } from "@components/ui/text/text";
import { useChatData } from "@contexts/chat-data";
import { useClasses } from "@styles";

export function ReportView() {
  const {
    ready,
    title,
    total,
    offset,
    limit,
    active,
    download,
    nextPage,
    prevPage,
  } = useChatData();

  const [downloadIcon, setDownloadIcon] = useState<
    "DownloadRegular" | "HourglassRegular"
  >("DownloadRegular");

  return (<>
    <Container className={useClasses('report-view')}>
      <Container className={useClasses("report-view-header")}>
        <Container className={useClasses("report-view-header-icon")}>
          <Page />
        </Container>

        <Heading size="max">
          {title || "Report"}
        </Heading>
      </Container>

      {!ready && (
        <Container className={useClasses('report-view-loading')}>
          <Hourglass className={useClasses('report-view-loading-icon')} />
        </Container>
      )}

      {ready && <>
        <Container className={useClasses("report-view-pagination")}>
          <Button
            disabled={offset === 0}
            icon="ArrowLeftRegular"
            hoverIcon="ArrowLeftRegular"
            onClick={prevPage}
          />

          <Text>
            Showing {Math.min(offset + 1, total)} - {
              Math.min(offset + limit, total)
            } of {total} entries
          </Text>

          <Button
            icon={downloadIcon}
            hoverIcon={downloadIcon}

            onClick={() => download(
              () => setDownloadIcon("HourglassRegular"),
              () => setDownloadIcon("DownloadRegular"),
            )}

            disabled={
              !active.length || downloadIcon === "HourglassRegular"
            }
          />

          <Button
            disabled={offset + limit >= total}
            icon="ArrowRightRegular"
            hoverIcon="ArrowRightRegular"
            onClick={nextPage}
          />
        </Container>

        <Container className={useClasses("report-view-content")}>
          <Table
            headers={active.slice(0, 1)[0]}
            content={active.slice(1)}
          />
        </Container>
      </>}
    </Container>
  </>);
}

